import { forwardRef } from 'react';
import type { SVGProps, Ref } from 'react';
type Props = SVGProps<SVGSVGElement>;
/**
 * @public
 */
const SvgTwitter = forwardRef((props: Props, svgRef: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1.5em"
    height="1.5em"
    fill="none"
    viewBox="0 0 24 24"
    ref={svgRef}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22.174 5.926a8.534 8.534 0 01-2.41.66 4.23 4.23 0 001.845-2.323 8.673 8.673 0 01-2.668 1.01 4.198 4.198 0 00-7.154 3.825 11.891 11.891 0 01-8.654-4.374 4.115 4.115 0 00-.569 2.112 4.2 4.2 0 001.868 3.495 4.185 4.185 0 01-1.902-.525v.052a4.2 4.2 0 003.368 4.119 4.26 4.26 0 01-1.888.072 4.213 4.213 0 003.929 2.916 8.42 8.42 0 01-5.207 1.796c-.333 0-.665-.02-.999-.057a11.943 11.943 0 006.449 1.885c7.726 0 11.946-6.396 11.946-11.935 0-.178 0-.358-.013-.537a8.48 8.48 0 002.1-2.174l-.04-.017z"
      clipRule="evenodd"
    />
  </svg>
));
SvgTwitter.defaultProps = {
  'aria-hidden': true,
  focusable: 'false',
  role: 'img',
};
export default SvgTwitter;
